"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'acl.table.resource': '资源',
};
